import {combineReducers} from "redux";
import lead from "./lead";
import context from "./context"
import {reducer as formReducer} from 'redux-form'
import calculatorReducer from "./calculator";
import {errorReducer} from "../errors/ErrorReducer";

let rootReducer = combineReducers({
  form: formReducer,
  calculator: calculatorReducer,
  lead: lead,
  context: context,
  error: errorReducer
});

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js